import request from '@/axios'


export function fetchCustomerList (customer_id, assignment_builder_user_id, payload) {
  return request({
    url:`/V1/assignment_builder/courseWork/${customer_id}/${assignment_builder_user_id}`,
    method: 'POST',
    data: payload
  })
}
export function submitMarks (customer_id, assignment_builder_user_id, payload) {
  return request({
    url:`/V1/assignment_builder/answerRemarkSave/${customer_id}/${assignment_builder_user_id}`,
    method: 'POST',
    data: payload
  })
}
export function ChnageStatusApi (customer_id, assignment_builder_user_id, payload) {
  return request({
    url:`/V1/assignment_builder/answerRemarkSave/${customer_id}/${assignment_builder_user_id}`,
    method: 'POST',
    data: payload
  })
}

export function statusChng (customer_id, assignment_builder_user_id, payload) {
  return request({
    url:`V1/assignment_builder/status/${customer_id}/${assignment_builder_user_id}`,
    method: 'POST',
    data: payload
  })
}
export function remindApi (customer_id, assignment_builder_user_id) {
  return request({
    url:`V1/assignment_builder/delay_notification/${customer_id}/${assignment_builder_user_id}`,
    method: 'GET'
  })
}

export function reportWorkSubmit (customer_id, assignment_builder_id, payload = null) {
  return request({
    url:`V1/assignment_builder/submitAnswers/${customer_id}/${assignment_builder_id}`,
    method:'POST',
    data:payload
  })
}

export function downloadCourseWorkPdf (customer_id, assignment_builder_user_id, payload) {
  return request({
    url:`V1/assignment_builder/downloadPdf/${customer_id}/${assignment_builder_user_id}`,
    method: 'POST',
    data:payload
  })
}

export function attachToCourse (customer_id, assignment_builder_id, payload) {
  return request({
    url:`V1/assignment_builder/attachToCourses/${customer_id}/${assignment_builder_id}`,
    method: 'POST',
    data:payload
  })
}
